import moment from "moment";
import dayjs from "dayjs";

export const FormatToLocalSystemDateTime = (date) => {
  return moment.utc(date).local().format("MM/DD/YYYY hh:mm A");
};

export const FormatDateOrWeekday = (date) => {
  return dayjs(date).format("MM/DD/YYYY HH:mm");
};

export const FormatToLocalTimeString = (date) => {
    return moment.utc(date).format("MM/DD/YYYY hh:mm:ss A");
};
